import { useContext } from "react";

import {
    GlobalDispatchContext,
    GlobalStateContext,
  } from "../../state/GlobalContextProvider"

const ToastAlert = ({props}) => {

    const dispatch = useContext(GlobalDispatchContext);
    const context_state = useContext(GlobalStateContext);


    if(context_state.toast===true){
        setTimeout(() => {
            dispatch({ type: "TRIGGER_TOAST" })
          }, 2000);
    }

  return null;
};

export default ToastAlert;
